import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import runtime from './runtime';
import realisations from './realisations';

export default combineReducers({
    routing: routerReducer,
    runtime,
    realisations,
});



// WEBPACK FOOTER //
// ./redux/reducers/index.js